import api from './axios';

export interface FooterData {
    logoUrl: string | null;
    logoSubtitle: string;
    contactTitle: string;
    address: string;
    phone: string;
    email: string;
    openingHours: string;
    infoTitle: string;
    facebookUrl: string | null;
    instagramUrl: string | null;
    twitterUrl: string | null;
    youtubeUrl: string | null;
    copyrightText: string;
    links: Array<{ title: string; url: string }>;
}

export const getPublicFooter = async (): Promise<FooterData> => {
    const response = await api.get('/public/footer');
    return response.data.data;
};
